import { render, staticRenderFns } from "./AnswersReportExamples.vue?vue&type=template&id=06a85c00&"
import script from "./AnswersReportExamples.vue?vue&type=script&lang=js&"
export * from "./AnswersReportExamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports